import { TextInput, TextInputNorlys } from '../BaseInput';
import { PhoneNumberInputProps } from './types';
import { useHandlePhoneNumberInputChange } from './util';

export const PhoneNumberInput = ({ label, onChange, value, ...rest }: PhoneNumberInputProps) => {
  const { phoneNumber, status, handleChangeEvent } = useHandlePhoneNumberInputChange(value, onChange);

  return (
    <TextInput
      {...{
        label: label ?? 'Telefonnummer',
        status,
        value: phoneNumber,
        placeholder: '22446688',
        onChange: handleChangeEvent,
        prefix: '+45',
        ...rest,
      }}
    />
  );
};

export const PhoneNumberInputNorlys = ({ label, onChange, value, ...rest }: PhoneNumberInputProps) => {
  const { phoneNumber, status, handleChangeEvent } = useHandlePhoneNumberInputChange(value, onChange);

  return (
    <TextInputNorlys
      {...{
        label: label ?? 'Telefonnummer',
        status,
        value: phoneNumber,
        placeholder: '22446688',
        onChange: handleChangeEvent,
        prefix: '+45',
        ...rest,
      }}
    />
  );
};
